import React from 'react';
import styled from 'styled-components';
import Icon from '../IconBase';

function Reschedule({ width, height, ...props }: any) {
  const size = width || height || 20;

  return (
    <Icon
      data-icon={'reschedule'}
      viewBox='0 0 100 100'
      width={size}
      height={size} {...props}>
      <path d='M69.32,12.7a2.71,2.71,0,0,1-1.13,2.2l-12.55,9a2.71,2.71,0,0,1-4.28-2.2V16.27a4.38,4.38,0,0,1-1.1.16A36.88,36.88,0,1,0,86.39,60.74,4.41,4.41,0,1,1,95,62.51,45.7,45.7,0,1,1,50.25,7.61a4.36,4.36,0,0,1,1.1.16V3.71a2.71,2.71,0,0,1,4.28-2.2l12.55,9A2.71,2.71,0,0,1,69.32,12.7ZM86.67,47.49A4.42,4.42,0,0,0,91,51.2a3.68,3.68,0,0,0,.69-.05,4.41,4.41,0,1,0-5-3.66ZM76.57,25.9a4.41,4.41,0,1,0-2.81-1A4.41,4.41,0,0,0,76.57,25.9ZM83.92,29a4.41,4.41,0,1,0,6,1.64A4.41,4.41,0,0,0,83.92,29ZM73.66,53.28A23.34,23.34,0,1,1,50.32,29.94,23.34,23.34,0,0,1,73.66,53.28ZM59.59,58.53,53.16,52.1V42.16a2.84,2.84,0,0,0-5.68,0v12.3l8.09,8.09a2.84,2.84,0,1,0,4-4Z' />

    </Icon>
  );
}

export default styled(Reschedule)``;